<template>
  <a-range-picker
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    :locale="{ lang: { rangePlaceholder: [] } }"
    v-model="modelList[name]"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import DatePicker from "ant-design-vue";
import 'ant-design-vue/lib/date-picker/style/index.less'
import Vue from 'vue'
Vue.use(DatePicker)
export default {
  mixins: [formMixin],
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
